import {createSelector} from 'reselect';

const getFollowingStrategiesState = state => state.followingStrategies;

export const getFollowingStrategies = createSelector(
  getFollowingStrategiesState,
  followingStrategiesState => followingStrategiesState,
);

export const getSortedFollowingStrategies = createSelector(getFollowingStrategies, followingStrategies =>
  followingStrategies.sort((a, b) => a.stats.balance - b.stats.balance),
);

export const getFollowingStrategiesCount = createSelector(getFollowingStrategies, ({length}) => length);

export const checkStrategyIsFollowing = strategyId =>
  createSelector(getFollowingStrategies, followingStrategies => {
    return Boolean(followingStrategies.find(({id}) => id === strategyId));
  });
